import axios from 'axios'

const state = () => ({
  pagesImages: []
})

const getters = {
  pagesImages(state) {
    return state.pagesImages
  }
}

const mutations = {
  SET_PAGES_IMAGES(state, payload){
    state.pagesImages = payload
  },
  DELETE_IMAGES(state, id){
    state.pagesImages = state.pagesImages.filter((x) => x.id != id);
  },
  ADD_IMAGES(state, data){
    state.pagesImages.push(data);
  },
  EDIT_PAGES_IMAGES(state, data){
    state.pagesImages = state.pagesImages.map((vm)=>{
      if(vm.id == data.id){ return data}
      else{ return vm }
    })
  }
}

const actions = {
  getPagesImages({commit}){
    axios.get('https://api.geomalaka.uz/api/main/menus_image/')
    .then((res)=>{
      commit("SET_PAGES_IMAGES", res.data)
      // this._vm.$toast('Successful', {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },
  getPagesImagesById({commit}, id){
  return axios.get(`https://api.geomalaka.uz/api/main/menus_image/${id}/`)
    .then((res)=>{
      commit("SET_PAGES_IMAGES", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{
      this._vm.$toast(error.message, {type: 'error'});
    })
  },
  deleteImage({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/menus_image/${id}/`)
    .then((res)=>{
      commit("DELETE_IMAGES", id)
      this._vm.$toast('Deleted', {type: 'success'});
    })
    .catch((error)=>{
      this._vm.$toast(error.message, {type: 'error'});
    })
  },
  addImages({commit}, payload){
   return axios.post(`https://api.geomalaka.uz/api/main/menus_image/`, payload)
    .then((res)=>{
      commit("ADD_IMAGES", res?.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{
      this._vm.$toast(error.message, {type: 'error'});
    })
  },
  editPagesImages({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/menus_image/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_PAGES_IMAGES", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }

}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

